import { Container, Popper } from './QuestionIconStyles';
import { useRef, useEffect, useState } from 'react';
import { COLORS } from '@/styles/colorTheme';
import { CircleHelp } from 'lucide-react';
import { cn } from '@/lib/utils';

interface QuestionIconProps {
  dp?: 'right' | 'left' | 'top' | 'bottom';
  desc?: string;
  width?: string;
  className?: string;
}

const QuestionIcon = ({ dp = 'right', desc, width = '580px', className }: QuestionIconProps) => {
  const [isHovering, setIsHovering] = useState(false);
  const ref = useRef<SVGSVGElement>(null);

  const mouseover = () => setIsHovering(true);
  const mouseleave = () => setIsHovering(false);

  useEffect(() => {
    const instance = ref.current;

    if (instance) {
      instance.addEventListener('mouseover', mouseover);
      instance.addEventListener('mouseleave', mouseleave);
    }

    return () => {
      if (instance) {
        instance.removeEventListener('mouseover', mouseover);
        instance.removeEventListener('mouseleave', mouseleave);
      }
    };
  }, []);

  return (
    <Container className={className}>
      <CircleHelp
        className="cursor-pointer"
        strokeWidth={1.5}
        size={16}
        color={COLORS.Text200}
        ref={ref}
      />
      <Popper width={width} isHovering={isHovering} dp={dp}>
        <div className={cn(`text-text-300 text-xs`)}>{desc}</div>
      </Popper>
    </Container>
  );
};

export default QuestionIcon;
